import React, { useState } from "react";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import LoginWithMpin from "./LoginWithMpin";
import LoginMpinPassWord from "./LoginMpinPassWord";
import ForgotPassOtp from "./ForgotPassOtp";
import { Link, useNavigate } from "react-router-dom";
import axios from "../../axios";
import { useDispatch } from "react-redux";
import {
  loginFailure,
  loginStart,
  loginSuccess,
} from "../../redux/userReducer";
import { CircularProgress } from "@mui/material";
import RunningLoader from "../../components/ui/runningLoader";
export default function LoginWithPassWord({
  studentDetails,
  setLogin,
  setRegister,
  setIsInProgress,
}) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isInLoading, setIsLoading] = useState(false);

  // 🔥 Naya state: Login success loader ke liye
  const [loginSuccessState, setLoginSuccessState] = useState(false);

  const [LoginWithPassWord, setLoginWithPassWord] = useState({
    loginInstedMpin: false,
    backArrow: false,
    forgotPass: false,
    loginSucess: false,
  });

  const schoolCode = localStorage.getItem("schoolCode");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlepasswordChange = (event) => {
    const { value } = event.target;
    setPassword(value);
  };

  const toggleshowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async () => {
    setIsLoading(true);
    dispatch(loginStart());

    try {
      let res = await axios.post(`/studentAuth/loginWithPassword`, {
        unique_id: studentDetails?.addmissionNumber,
        password: password,
        school_code: schoolCode,
      });

      if (res) {
        dispatch(loginSuccess(res.data.data));
        localStorage.setItem(
          "School_id",
          JSON.stringify(res?.data?.data?.addmission_no),
        );
        localStorage.setItem(
          "AuthToken",
          JSON.stringify(res.data?.data?.accessToken),
        );
        localStorage.setItem(
          "features",
          JSON.stringify(res.data?.data?.features),
        );
        localStorage.setItem("homeSideMenu", "Dashboard");

        // 🔥 Yahan navigate nahi karenge, loader trigger karenge
        setLoginSuccessState(true);

        // 3 second baad direct dashboard
        setTimeout(() => {
          navigate("/HomePage");
        }, 3000);
      }
    } catch (error) {
      dispatch(loginFailure());
      setErrorMessage(error?.response?.data?.message || "Invalid Password");
      setIsLoading(false);
      console.log(error);
    }
  };

  // 🔥 Agar login successful hai, toh loader dikhao
  if (loginSuccessState) {
    return <RunningLoader />;
  }

  return (
    <div>
      {!LoginWithPassWord.loginInstedMpin &&
        !LoginWithPassWord.backArrow &&
        !LoginWithPassWord.forgotPass &&
        !LoginWithPassWord.loginSucess && (
          <div className="ContainerRegister h-100">
            <div className="row">
              <div className="col-md-3 p-0 bannerContainer">
                <img
                  className="bannerImg"
                  alt="icon"
                  src="/LoginRegister/BannerImg.png"
                ></img>
              </div>
              <div className="col-md-9 RegisterDetailContainer">
                <>
                  <div
                    className="backLoginIcon"
                    onClick={(e) =>
                      setLogin((prev) => ({
                        ...prev,
                        mpinLogin: false,
                        passwordLogin: false,
                      }))
                    }
                  >
                    <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                  </div>

                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleLogin();
                    }}
                  >
                    <div className="InsideDetailCpntainer">
                      <div className="d-flex justify-content-center">
                        <img
                          className="registrationIcon"
                          src="/StudentImg/BreathSchoolLogo.png"
                          alt="icon"
                        />
                      </div>
                      <div className="d-flex justify-content-center headerRegistration mt-3">
                        Welcome back!
                      </div>
                      <div className="UnlockFaceIdText d-flex justify-content-center mt-2 ">
                        Login with Password
                      </div>

                      <div className="d-flex justify-content-between p-3 align-items-center registrationMPinInput mt-4">
                        <input
                          type="text"
                          className="otpInput"
                          readOnly="true"
                          value={studentDetails?.addmissionNumber}
                        />
                      </div>

                      <div
                        style={{ borderColor: errorMessage && "#D40D12" }}
                        className="d-flex justify-content-between p-3 align-items-center registrationMPinInput mt-4"
                      >
                        <input
                          max={50}
                          style={{ borderColor: errorMessage && "red" }}
                          type={showPassword ? "text" : "password"}
                          id="password"
                          className="otpInput"
                          name="password"
                          placeholder="Enter Password"
                          value={password}
                          onChange={handlepasswordChange}
                          required
                          autoComplete="off"
                          minLength={8}
                          maxLength={64}
                        />
                        <span
                          onClick={toggleshowPassword}
                          style={{ cursor: "pointer", color: "#555" }}
                        >
                          {showPassword ? <FiEye /> : <FiEyeOff />}
                        </span>
                      </div>
                      <div className="mt-2">
                        {errorMessage && (
                          <span className="text-red-600 text-[16px] font-medium flex items-center gap-1">
                            ⚠️ {errorMessage || "Invalid Password"}
                          </span>
                        )}
                      </div>
                      <div className="d-flex flex-column justify-content-center mt-4">
                        <button
                          type="submit"
                          disabled={password === "" || isInLoading}
                          className="RegisterBtn"
                          style={{
                            opacity: password === "" || isInLoading ? 0.6 : 1,
                            cursor:
                              password === "" || isInLoading
                                ? "not-allowed"
                                : "pointer",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {isInLoading && (
                            <CircularProgress
                              size={18}
                              sx={{ color: "#fff" }}
                            />
                          )}
                          {isInLoading ? "Logging in..." : "Login"}
                        </button>
                      </div>
                      <div
                        className="skipfacetext d-flex justify-content-center mt-3"
                        onClick={() =>
                          setLoginWithPassWord({
                            ...LoginWithPassWord,
                            forgotPass: true,
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        Forgot Password?
                      </div>
                      <div className="d-flex justify-content-center mt-4">
                        <div
                          className="loginpasswordInstead mt-5"
                          onClick={(e) => {
                            setLoginWithPassWord({
                              ...LoginWithPassWord,
                              loginInstedMpin: true,
                            });
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Login with PIN instead
                        </div>
                      </div>
                    </div>
                  </form>
                </>
              </div>
            </div>
          </div>
        )}
      {LoginWithPassWord.loginInstedMpin && (
        <LoginWithMpin
          studentDetails={studentDetails}
          setLogin={setLogin}
          setRegister={setRegister}
          setIsInProgress={setIsInProgress}
        />
      )}
      {LoginWithPassWord.backArrow && (
        <LoginMpinPassWord
          studentDetails={studentDetails}
          setLogin={setLogin}
          setIsInProgress={setIsInProgress}
        />
      )}
      {LoginWithPassWord.forgotPass && (
        <ForgotPassOtp studentDetails={studentDetails} />
      )}
    </div>
  );
}
